import styled from 'styled-components';
import { FormContainer } from '~/components/Form';

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const KpiForm = styled(FormContainer)`
  h4 {
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.blue};
  }

  section {
    > div {
      & + div {
        margin-left: 16px;
      }
    }
  }

  .deadline_days,
  .weight {
    width: 10%;
  }

  .type {
    width: 20%;
  }

  .evaluator_id {
    width: 30%;
  }

  .description {
    width: 35%;
  }

  .generate_schedule_task {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
  }
`;
